exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".formItem-5b408{margin-bottom:0}.allocationSelect-08e19{width:100%}", ""]);

// Exports
exports.locals = {
	"formItem": "formItem-5b408",
	"allocationSelect": "allocationSelect-08e19"
};